<app-warning-button (click)="onLogoutClick()" [disabled]="!isAuthenticated()" icon="logout" label="Esci"
                    raised></app-warning-button>
